<script>
  // pages
  import Front from '@/pages/Front.svelte';

  // Router
  import { Router, Route, NotFound, redirect } from '@/router/Index.js';

  export let data;
  
  // let showModal = true;

</script>

<main>
  <Router>
    <Route path="/" component="{Front}" {data}></Route>
  </Router>
</main>
